import { ImgHTMLAttributes, useState } from 'react'

interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string | any
  alt: string
  width?: number
  height?: number
  className?: string
  priority?: boolean
}

export default function Image({ src, alt, width, height, className, priority, ...props }: ImageProps) {
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)

  // Handle Vite asset imports
  // Vite returns image imports as strings (URLs)
  // But we also handle object cases for compatibility
  let imageSrc: string = ''
  
  if (!src) {
    imageSrc = ''
  } else if (typeof src === 'string') {
    // Vite imports are strings
    imageSrc = src
  } else if (typeof src === 'object') {
    // Some bundlers return objects with src/default properties
    imageSrc = (src as any).src || (src as any).default || (src as any).url || ''
  } else {
    // Convert anything else to string
    imageSrc = String(src)
  }

  // If no valid src, show placeholder
  if (!imageSrc) {
    return (
      <div
        className={className}
        style={{
          width: width,
          height: height,
          backgroundColor: '#f3f4f6',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span style={{ fontSize: '10px', color: '#9ca3af' }}>No image</span>
      </div>
    )
  }

  return (
    <img
      src={imageSrc}
      alt={alt}
      width={width}
      height={height}
      className={className}
      loading={priority ? 'eager' : 'lazy'}
      onLoad={() => setIsLoading(false)}
      onError={(e) => {
        console.error('Image failed to load:', { imageSrc, originalSrc: src, alt })
        setError(true)
        setIsLoading(false)
      }}
      style={{
        opacity: isLoading ? 0 : 1,
        transition: 'opacity 0.3s',
      }}
      {...props}
    />
  )
}

